import { render, staticRenderFns } from "./DiagramPremisesPassed.vue?vue&type=template&id=7a0f6d1e&"
import script from "./DiagramPremisesPassed.vue?vue&type=script&lang=js&"
export * from "./DiagramPremisesPassed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
